{
  "title": "Inbox",
  "totalBadge": "{{count}} items",
  "viewAll": "View all",
  "loading": "Loading…",
  "emptySection": "All caught up",
  "loadError": "Couldn't load this section"
}
